import palette from '@lib/core/src/theme/palette';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Typography } from '@mui/material';

import {
  FailedToGenerateWrapper,
  TryAgainButton
} from '@/components/Meeting/components/MeetingOverview/MeetingOverviewStyles';

interface FailedToGenerateProps {
  onRetryClicked: () => void;
  title?: string;
  description?: string;
}

const FailedToGenerate = ({ onRetryClicked, title, description }: FailedToGenerateProps) => (
  <FailedToGenerateWrapper>
    <Typography fontSize={'16px'} color={palette.black}>
      {title}
    </Typography>
    <Typography fontSize={'13px'} color={palette.grey[500]}>
      {description}
    </Typography>
    {onRetryClicked && (
      <TryAgainButton startIcon={<AutorenewIcon />} onClick={onRetryClicked}>
        Try Again
      </TryAgainButton>
    )}
  </FailedToGenerateWrapper>
);

export default FailedToGenerate;
